var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFailedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.3,
    height: 39.3,
    viewBox: "0 0 39.3 39.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "failed",
    d: "M19.65,39.3A19.65,19.65,0,1,1,39.3,19.65,19.673,19.673,0,0,1,19.65,39.3Zm0-36.844A17.194,17.194,0,1,0,36.844,19.65,17.213,17.213,0,0,0,19.65,2.456Zm6.3,24.747a1.226,1.226,0,0,1-.871-.361l-5.428-5.455-5.454,5.43a1.229,1.229,0,0,1-1.734-1.741l5.455-5.428-5.43-5.454a1.229,1.229,0,1,1,1.741-1.734l5.428,5.455,5.454-5.43a1.229,1.229,0,1,1,1.734,1.741l-5.455,5.428,5.43,5.454a1.228,1.228,0,0,1-.871,2.1Z",
    fill: "#f96361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFailedStatus);
export default __webpack_public_path__ + "static/media/IconFailedStatus.1d8e8f63.svg";
export { ForwardRef as ReactComponent };